"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = require("./styled");
require("./snowy.css");
var Snowy = function (_a) {
    var children = _a.children;
    (0, react_1.useEffect)(function () {
        addSnow();
    }, []);
    var count = 0;
    var addSnow = function () {
        var wrapper = document.querySelector("#snow-wrapper");
        var snow = document.createElement("span");
        snow.classList.add("snow");
        snow.style.left = "".concat(Math.random() * (window.innerWidth - 1) + 1, "px");
        snow.style.animationDuration = "".concat(Math.random() * (20 - 8) + 8, "s");
        snow.style.animationDelay = "".concat(Math.random() * (10 - 1) + 1, "s");
        snow.style.opacity = "".concat(Math.random());
        wrapper === null || wrapper === void 0 ? void 0 : wrapper.append(snow);
        if (count < 250) {
            window.requestAnimationFrame(addSnow);
            count++;
        }
    };
    return react_1.default.createElement(styled_1.Snow, { id: "snow-wrapper" }, children);
};
exports.default = Snowy;
